import { texts } from '../i18n';
import { Box, Link } from '@mui/material';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export function ForgottenPasswordLink({ onClick }: { onClick: () => void }) {
    const { language } = useLanguage();
    return (
        <Box
            sx={{
                color: theme => theme.palette.blue.main,
                fontWeight: 700,
                paddingBottom: theme => theme.spacing(3),
            }}
        >
            <Link underline="hover" onClick={() => onClick()}>
                {texts[language].forgotPassword}
            </Link>
        </Box>
    );
}
